"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIEWPORT_SIZES = void 0;
/* eslint-disable import/prefer-default-export */
var VIEWPORT_SIZES = exports.VIEWPORT_SIZES = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];